import { MutationTree } from 'vuex';

import { State } from './state';
import { MessageMutationTypes } from './mutation-types';
import { SegNotificacaoModel } from '@/models/message/seg-notificacao.model';

export type Mutations<S = State> = {
  [MessageMutationTypes.SET_MESSAGES](state: S, messages: SegNotificacaoModel[]): void;
  [MessageMutationTypes.ADD_MESSAGE](state: S, message: SegNotificacaoModel): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MessageMutationTypes.SET_MESSAGES](state: State, messages: SegNotificacaoModel[]) {
    state.messages = messages;
  },
  [MessageMutationTypes.ADD_MESSAGE](state: State, message: SegNotificacaoModel) {
    state.messages.push(message);
  }
};
